// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__5Pikq","title":"Chart_title__ccXMD","bar":"Chart_bar__YY8W8"};